import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ElasticSearch from '../../homepage/header-banner/ElasticSearch';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import CloudconsultCp from '../../homepage/consult/cloudconsult-cp';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBox from '../../container/Box/Components/CardBox';
// import { MuiGrid } from '@mui/material';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function ClustercloudelasticsearchENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Elastic Search Engine")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}

                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Search Engine Supporting Sharding and Replication in Kubernetes Cluster</p>",
                            `<p class='typo-14'>Elasticsearch is a Lucene-based search engine that supports sharding for fast data access.</p>
                            <p class='typo-14'>When a container (POD) fails, a replica container (POD) maintains service continuity, enabling a zero-downtime system.</p>
                            <p class='typo-14'>Search engine operated across all Hanbiro software systems, with 15 years of operational expertise.</p>`)}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>High-performance Persistent Volumes optimized for I/O</p>",
                            `<p class='typo-14'>Operated on SSD-based PV volumes, with 3 replica containers (PODs) forming a single service.</p>
                            <p class='typo-14'>Even if hardware failures occur on Kubernetes worker nodes, service continues seamlessly through replica containers (PODs) on other nodes.</p>`
                        )}
                        </MuiGrid>
                        {/*
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "컨테이너(POD)하드웨어의 자유로운 구성으로 최적의 클러스터 구현",
                            "컨테이너(POD)에 할당되는 서버자원은 고객의 요구에 맞게 할당할 수 있으며, ElasticSearch 클러스터 시스템을 자유롭게 구성할 수 있습니다."
                            )}
                        </MuiGrid>
                        */}
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Automatically reassigns containers (PODs) during hardware failures to ensure zero downtime.</p>",
                            `<p class='typo-14'>Each Elasticsearch container (POD) consists of 3 replica nodes per service unit.</p>
                            <p class='typo-14'>The replicas are distributed across multiple Kubernetes worker nodes for load balancing and stability.</p>`
                        )}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12} sm={12}>{CardBox(
                            "<p class='typo-21-sm typo-medium typo-black'>Automatically Scale Out for Container Expansion and Load Balancing.</p>",
                            `<p class='typo-14'>The system automatically adjusts (adds or removes) the number of containers (PODs) based on CPU utilization, memory usage, or other custom metrics, ensuring optimal performance.</p>
                            <p class='typo-14'>This allows you to run the service without needing additional hardware resources for scaling purposes.</p>
                            <p class='typo-14'>It is a cluster solution designed for efficient load balancing and cost-effective resource utilization.</p>`
                        )}
                        </MuiGrid>
                        <DividerComponent />
                        <MuiGrid item xs={12}>{Imagecloudcompute("https://www.hanbiro.com/cloud/library/cluster-cloud-elastic-search/elasticsearch_cluster.svg")}</MuiGrid>
                        <DividerComponent />

                        {/* <ElasticSearch /> */}
                        {/* <CloudconsultCp /> */}
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>


            {/* <Cloudconsult /> */}
            {/* <Footer /> */}
            <FooterEn />
        </Sysfont>

    );

};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClustercloudelasticsearchENG;